import React, { Component } from 'react';
import { SvgGetPoints, FillInGaps, Normalize } from './HelpFunctions';
import ImageUploading from 'react-images-uploading';
import { svg } from './svg';
import MiniDraw from './MiniDraw';
import TextWrite from './TextWrite';
import HowItWorks from './HowItWorks';

class ExampleSelect extends Component {
	constructor(props) {
		super(props);
		this.textarea = React.createRef();
		this.state = {
			example_circle: Math.floor(Math.random() * 100)
		}
	}

	use() {
		this.useData(this.textarea.current.value);
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidMount() {
		this._isMounted = true;
		this.setExamplePoints();
	}

	setExamplePoints() {
		this.setState({
			example_points: this.svgToPoints(this.svgToPath(svg[this.state.example_circle % svg.length][1])),
			example_circle: this.state.example_circle + 1
		});
	}

	useSvg(points) {
		if (points?.length) {
			this.props.setPointsCallback(points);
			this.props.setMode("view");
			return true;
		}
		return false;
	}

	svgToPoints(paths) {
		try {
			let data = SvgGetPoints(paths);
			let result = FillInGaps(data);
			if (result.length > 0) {
				result = Normalize(result, 0.95);
				return result;
			}
		} catch (e) {
			console.log("Exception in", paths);
		}
		return undefined;
	}

	svgToPath(svg) {
		try {
			let parser = new DOMParser();
			let doc = parser.parseFromString(svg, "text/html");
			let paths = doc.getElementsByTagName("path");
			if (paths.length > 0) {
				return paths;
			}
		} catch {
		}
		return undefined;
	}

	render() {
		const svgUpload = (imageList) => {
			try {
				let encoded = imageList;
				encoded = encoded[0].data_url.split(";")[1].split(",")[1];
				let parser = new DOMParser();
				let doc = parser.parseFromString(atob(encoded), "text/html");
				let paths = doc.getElementsByTagName("path");
				if (paths.length > 0) {
					{
						// Upload to server for fun
						const formData = new FormData();
						formData.append("svg", new XMLSerializer().serializeToString(doc));

						const requestOptions = {
							method: 'POST',
							headers: { 'Content-Type': 'multipart/form-data' },
							body: formData
						};
						fetch('/dump/', requestOptions);
					}
					this.setState({ error: undefined });
					this.useSvg(this.svgToPoints(paths));
				} else {
					this.setState({ error: "Couldn't parse data" });
				}
			} catch (e) {
				console.log(e);
				this.setState({ error: "Not valid image" });
				window.setInterval(() => {
					this.setState({ error: undefined });
				}, 2000);
			}
		}

		const svgExample = (imageList) => {
			let paths = this.svgToPath(imageList);
			if (paths) {
				this.setState({ error: undefined });
				this.useSvg(this.svgToPoints(paths));
			} else {
				this.setState({ error: "Couldn't parse data" });
			}
		};

		let svgArray = [];
		svg.forEach((item, index) => {
			svgArray.push(
				<img src={item[0]} key={index} alt="example"
					onClick={() => svgExample(item[1])} width="100px" height="100px" />
			);
		});



		return (
			<div>
				{
					this.state?.error ?
						<div style={{ border: "1px solid black", backgroundColor: "red" }}>
							{this.state.error}
						</div>
						:
						<></>
				}
				<p>
					<i>
						<a href="https://en.wikipedia.org/wiki/Fourier_series">Fourier series</a>,
						a weighted sum of sinusoids having a common period,
						the result of Fourier analysis of a periodic function.
					</i>
				</p>
				<p>
					...or in this case:  We create several vectors (clocks or circles if you prefer)
					and let each of them rotate at different speed. Then we plot the endpoint after
					adding all these up creating a drawing.
					<button onClick={() => this.setState({ showHowTo: !this.state.showHowTo })}>
						Read more.
					</button>
				</p>
				<div style={{ display: this.state?.showHowTo ? "block" : "none" }}>
					<HowItWorks />
				</div>

				<table>
					<tr>
						<td>
							<ImageUploading
								onChange={svgUpload}
								dataURLKey="data_url"
							>
								{({
									// imageList,
									onImageUpload,
									// onImageUpdate,
									// onImageRemove,
									isDragging,
									dragProps,
								}) => (
									<button
										style={{
											backgroundColor: isDragging ? 'red' : '',
											fontSize: "200%"
										}}
										onClick={onImageUpload}
										{...dragProps}
									>
										Drop svg here<br />or click to upload
									</button>
								)}
							</ImageUploading>

						</td>
						<td>
							<TextWrite
								setPointsCallback={(points) => this.props.setPointsCallback(points)}
								setMode={(mode) => this.props.setMode(mode)}
							/>

						</td>
					</tr>
				</table>
				<MiniDraw
					style={{ float: "right" }}
					running={true}
					width={300}
					height={200}
					points={this.state.example_points}
					onClick={() => { this.setExamplePoints() }}
					settings={{
						speed: 40,

						circles_show: true,
						circles_pixels: 1,
						circles_color: "#cccccc",

						arrows_show: true,
						arrows_pixels: 1,
						arrows_color: "#888888",

						origin_show: true,
						origin_color: "#eeeeee",
						origin_pixels: 1,

						path_pixels: 2,
						path_color: "#8888ff",
						path_show: true,

						text_show: true,

						number_of_circles: 400,
						zoom_to_circle: 1
					}}
				/>
				<p>
					Click on image below to try it.<br />
					{svgArray}
					<br />
					<a href="https://svgsilh.com/" rel="noopener noreferrer" target="_blank">Credits to SVG Silh where I downloaded them.</a>
				</p>
			</div>
		);
	}
}

export default ExampleSelect;